import React from 'react'
import HelpItem from './HelpItem'

const Questions = props => {
  const question1 = <p className='txt-body-sm'>Clientes titulares de cartões de crédito itaucard ou Personnalité ativo das variantes internacional, gold, platinum, signature, black e infinite com programa de pontos que acumula pontos no iupp que realizarem pagas integralmente com o seu cartão no shopping iupp.<br /><br /> *Não participam os cartões de outros bancos ou cartões de parcerias, que possuem programas próprios, como: Credicard, Hipercard, Pão de açúcar, Compre bem, Extra, Passai, Sams, Walmart, Ipiranga, Magazine Luiza, Polishop, Pontofrio, Marisa, Business, Fiat, Ford, Volkswagen, Mitsubishi, Tim, Vivo, Livraria Cultura, N-card, Brastemp, Sulamerica, Tudo Azul, Latam Pass e Samsung.</p>
  const question2 = <p className='txt-body-sm'>O cashback com o crédito na fatura será realizado na fatura do cartão de crédito itaucard ou Personnalité ativo. Caso o cliente seja titular de mais de um cartão, o crédito na fatura será realizado no cartão de crédito Itaucard ou Personnalité de maior variante, exemplo: se tiver um cartão internacional e um black ativos, o crédito será realizado no cartão black.<br /><br /> *Não é possível escolher outro cartão para a realização do crédito, que não seja o cartão ativo de maior variante.</p>
  const question3 = <p className='txt-body-sm'>Após a compra com o seu cartão no shopping iupp, você receberá os pontos (3 pontos por real gasto) em até 40 dias. Depois do recebimento dos pontos você poderá realizar a troca dos pontos por crédito na sua fatura. A partir da solicitação, seu pedido passará por análise em até 48h. Sendo aprovado, o valor aparecerá na sua fatura em aberto em até 5 dias úteis.</p>

  const faqItems =
    [
      {
        question: 'Quem é elegível para ganhar o cashback?',
        response: question1
      },
      {
        question: 'Em qual cartão é realizado o cashback com crédito em fatura?',
        response: question2
      },
      {
        question: 'Em quanto tempo o crédito aparecerá na minha fatura?',
        response: question3
      }
    ]
  return (
    <div className='questions'>
      <div className='container'>
        <h4>Ainda tem dúvidas? Veja nossas perguntas frequentes.</h4>
        <div className='containerCollapse'>
          {
            faqItems.map((item) => (
              <HelpItem {...item} />
            ))
          }
        </div>
        <div className='divSpacer' />
      </div>
    </div>
  )
}

export default Questions



// WEBPACK FOOTER //
// ./src/features/LandingPage/LandingCashbackBlack/Questions/Questions.js